module.exports = __webpack_public_path__ + "static/media/simbolo.9aa0018d.png";